import LoaderTipo from './LoaderTipo';

const loaderAction = (estado) => {
  return {
    type: LoaderTipo.data.SHOW_LOADER,
    payload: { showLoader: estado }
  }
};

export default loaderAction;